"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var react_2 = require("swiper/react");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var Slide_1 = __importDefault(require("./Slide"));
require("./styles.scss");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DesktopProviders = function (_a) {
    var providers = _a.providers;
    var t = (0, next_intl_1.useTranslations)('translation');
    var slider = (0, react_1.useRef)(null);
    var blocks = (0, apps_shared_1.useGenerateSlideBlocks)({
        cards: providers,
        cardsInSlide: 6,
        countSlides: Math.ceil(providers.length / 6),
    });
    if (blocks.length === 0)
        return null;
    return (react_1.default.createElement("div", { id: "providers", className: styles_module_scss_1.default.container },
        react_1.default.createElement(ui_components_1.TopBar, { title: t('providers'), linkAddress: null, showNavigationButtons: blocks && blocks.length > 1, setPrevSlide: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); }, setNextSlide: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slideNext(); } }),
        react_1.default.createElement("div", { className: "providers-slider" },
            react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                    slider.current = swiper;
                }, loop: true, spaceBetween: 100, slidesPerView: 1, pagination: { clickable: true }, autoplay: false, lazy: true, preloadImages: false }, blocks.map(function (block, idx) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "slideProviders".concat(idx) },
                react_1.default.createElement(Slide_1.default, { providers: block }))); })))));
};
exports.default = DesktopProviders;
